module.exports = __webpack_public_path__ + "img/4.78010bd4.svg";